import {Component} from '@angular/core';
import {BlockBaseComponent} from "../block-base/block-base.component";
import {StoreSelectorsService} from "../../../../services/store-selectors.service";
import {MatDialog} from "@angular/material/dialog";
import {TranslocoService} from "@ngneat/transloco";
import {DialogCorsComponent} from "../../../../components/dialog-cors/dialog-cors.component";

@Component({
    selector: 'app-scene-block-ext-video',
    templateUrl: './block-ext-video.component.html',
    styleUrls: ['./block-ext-video.component.scss']
})
export class BlockExtVideoComponent extends BlockBaseComponent {

    resourceName = '';

    constructor(private translocoService: TranslocoService, public override storeSelector: StoreSelectorsService, public override dialog: MatDialog) {
        super(storeSelector, dialog);
    }

    override submit(formValues) {
        super.submit(formValues);
    }

    override componentInit() {
        super.componentInit();
    }

    override componentStoreUpdates() {
        super.componentStoreUpdates();
    }

    openCors() {
        this.dialog.open(DialogCorsComponent, {
            width: '400px'
        });
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [
            {
                type: "input",
                value: "",
                label: this.translocoService.translate('general.link', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "src",
                restrictChar: 'basic3',
                storePath: 'Data[0].LINK[0].$.src'
            },
            {
                type: "input",
                value: '1',
                label: this.translocoService.translate('general.volume', {}, this.translocoService.getActiveLang()),
                inputType: "range",
                min: 0,
                max: 1,
                step: 0.1,
                name: "volume",
                storePath: 'Data[0].LINK[0].Video[0].$.volume'
            },
            {
                type: "checkbox",
                value: '1',
                label: this.translocoService.translate('general.autoRewind', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "autoRewind",
                storePath: 'Data[0].LINK[0].Video[0].$.autoRewind'
            },
            {
                type: "checkbox",
                value: '1',
                label: this.translocoService.translate('general.maintainRatio', {}, this.translocoService.getActiveLang()),
                name: "maintain",
                storePath: 'Data[0].LINK[0].AspectRatio[0].$.maintain'
            }
            // ,{
            //       type: "checkbox",
            //       value: '1',
            //       label: this.translocoService.translate('general.gpu', {}, this.translocoService.getActiveLang()),
            //       name: "gpu",
            //       storePath: '$.gpu'
            //   }
        ];
    }
}

